import { em } from 'polished'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import { ResizeContext } from 'contexts/Resize'
import { Col, Row } from 'styles/components/layout'

import CartEmptyCostBlockNew from '../CartEmptyCostBlockNew'

import {
  DynamicImageStyled,
  RowStyled,
  ButtonContent,
  ButtonRoundedStStyled,
  TextLHStyled,
  Title,
  TextCartEmpty,
  DiscountLabelStyled,
  CostBlock,
  ItemTitle,
  ColStyled,
} from './styles'

const CartEmptyItemNew = props => {
  const {
    boxes,
    currencyCode,
    dict,
    discount,
    productInfo,
    productConfig,
    productType,
    handleIncrease,
    intlCode,
    texts,
    isCartInitOrUpdate,
    precision,
    className,
  } = props
  const { mobile } = useContext(ResizeContext)
  const handleIncreaseCurrent = () =>
    handleIncrease({
      productType,
      isSubscription: false,
    })

  const imageContent = boxes ? (
    <DynamicImageStyled
      image={boxes}
      imageSizes={{ xs: 55, md: 80, lg: 130 }}
      imageType="png"
      alt=""
    />
  ) : null

  const isZeroPrice = productInfo.price === 0 || productInfo.currentPrice === 0 || productInfo.priceWebsite === 0

  return (
    <RowStyled
      className={className}
      indent={{ xs: 0, md: 40, lg: 40 }}
      alignItems={{ lg: 'center' }}
    >
      <Col width={{ xs: em(80), md: em(120), lg: em(170) }} flexShrink="0">
        {imageContent}
      </Col>
      <Col
        flexGrow={{ md: 1 }}
        width={{ xs: `calc(100% - ${em(80)})`, md: 'auto' }}
      >
        <Row alignItems={{ lg: 'center' }}>
          <Col flexGrow={{ lg: 1 }}>
            <Title>
              <ItemTitle
                dangerouslySetInnerHTML={{
                  __html: dict.kits[productType].title,
                }}
              />
              {discount > 0 && !isZeroPrice && (
                <>
                  &nbsp;
                  <DiscountLabelStyled
                    text={''}
                    isWithFilling={true}
                    isWithoutShift={true}
                    isShortLabel={true}
                    value={discount}
                  />
                </>
              )}
            </Title>
          </Col>
          <Col width={{ xs: 1, lg: 5.5 / 12 }}>
            <TextCartEmpty
              dangerouslySetInnerHTML={{
                __html: texts.products[productType].content,
              }}
            />
          </Col>
        </Row>
      </Col>
      <ColStyled
        marginLeft={{ xs: em(80), md: 0 }}
        marginTop={{ xs: em(16), md: 0 }}
        width={{ lg: 3 / 12 }}
        height={{ md: '100%', lg: 'auto' }}
      >
        <Row
          flexDirection={{ xs: 'column', lg: 'row' }}
          alignItems={{ lg: 'center' }}
        >
          <Col width={{ lg: 2 / 5 }}>
            {!isZeroPrice && (
              <CostBlock>
                <CartEmptyCostBlockNew
                  key={`key-${intlCode}-${currencyCode}`}
                  intlCode={intlCode}
                  currencyCode={currencyCode}
                  cost={productInfo.currentPrice}
                  realCost={productInfo.price}
                  precision={precision}
                  showCrossedCost={!!productConfig.discount}
                  isLoading={isCartInitOrUpdate}
                  inRow={mobile ? true : false}
                  size={mobile ? 'base' : 'cartEmptyPrice'}
                />
              </CostBlock>
            )}
          </Col>
          <ColStyled width={{ lg: 3 / 5 }} marginTop={{ xs: em(20), lg: 0 }}>
            <ButtonRoundedStStyled
              isDisabled={isZeroPrice}
              forwardedAs="button"
              size={mobile ? 'fit' : 'base'}
              onClick={handleIncreaseCurrent}
            >
              <ButtonContent>
                <TextLHStyled
                  dangerouslySetInnerHTML={{ __html: isZeroPrice ? dict.buttons.out_of_stock : dict.buttons.add_to_cart }}
                />
              </ButtonContent>
            </ButtonRoundedStStyled>
          </ColStyled>
        </Row>
      </ColStyled>
    </RowStyled>
  )
}

CartEmptyItemNew.propTypes = {
  boxes: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  dict: PropTypes.object.isRequired,
  discount: PropTypes.number.isRequired,
  intlCode: PropTypes.string.isRequired,
  productConfig: PropTypes.object.isRequired,
  productInfo: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isCartInitOrUpdate: PropTypes.bool.isRequired,
  precision: PropTypes.number,
  handleIncrease: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default React.memo(CartEmptyItemNew)
